import React from "react";

import Breadcrumb from "../components/Breadcrumb";
import ViewProfileLayer from "../components/ViewProfileLayer";


const ViewProfilePage = () => {
  return (
    <>
      <Breadcrumb title="Mi Perfil" />
      <ViewProfileLayer />
    </>
  );
};

export default ViewProfilePage; 
